export default {
    landing: {
        title: 'Bitdeer App',
        sub: 'ワンストップのビットコインマイニング',
        desc: '登録・累積・出金・ハッシュレート産出確認、すべて App で完結',
        register: '今すぐ登録',
        login: 'アカウントをお持ちですか？ログイン',
        feature1: '予約報酬 10 USDT / 日',
        feature2: '10 USDT から出金可能、手数料 0%',
        feature3: '24時間日本語サポート'
    },
    login: {
        title: 'ログイン',
        sub: 'おかえりなさい',
        email: 'メールアドレス',
        emailPlaceholder: 'メールアドレスを入力',
        password: 'パスワード',
        passwordPlaceholder: 'パスワードを入力',
        submit: 'ログイン',
        noAccount: 'アカウントをお持ちでないですか？',
        register: '今すぐ登録',
        success: 'ログイン成功',
        emailRequired: 'メールアドレスを入力してください',
        emailInvalid: 'メールアドレスの形式が正しくありません',
        passwordRequired: 'パスワードを入力してください'
    },
    register: {
        title: '新規登録',
        sub: 'マイニングの旅を始めましょう',
        email: 'メールアドレス',
        emailPlaceholder: 'メールアドレスを入力',
        code: '認証コード',
        codePlaceholder: '認証コードを入力',
        sendCode: 'コードを送信',
        resend: '再送信（{s}秒）',
        codeSent: '認証コードを送信しました',
        password: 'パスワード',
        passwordPlaceholder: '6文字以上',
        referral: '紹介コード',
        referralPlaceholder: '紹介コードを入力',
        agree: '以下に同意します：',
        terms: '利用規約',
        and: 'および',
        privacy: 'プライバシーポリシー',
        submit: '今すぐ登録',
        hasAccount: 'アカウントをお持ちですか？',
        login: 'ログイン',
        success: '登録完了',
        emailRequired: 'メールアドレスを入力してください',
        emailInvalid: 'メールアドレスの形式が正しくありません',
        codeRequired: '認証コードを入力してください',
        passwordRequired: 'パスワードを入力してください',
        passwordTooShort: 'パスワードは6文字以上',
        referralRequired: '紹介コードを入力してください',
        agreeRequired: '利用規約に同意してください',
        registerSuccess: '登録完了、ログインしてください'
    },
    success: {
        title: '予約完了！',
        sub: 'アカウントの準備が整いました',
        userId: 'ユーザーID',
        email: 'メールアドレス',
        inviteCode: 'あなたの紹介コード',
        copy: 'コピー',
        copied: '紹介コードをコピーしました',
        tip: '紹介コードを友達に共有すると、登録後にあなたが上位になります',
        downloadAndroid: 'Android ダウンロード',
        downloadIos: 'iOS ダウンロード',
        platformTip: 'ご予約は {platform} 版です',
        backHome: 'ホームへ戻る'
    }
}